<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
     <div class="card p-0 lg:min-h-[calc(100vh_-_theme('spacing.header')_*_1.4)] xl:min-h-[calc(100vh_-_theme('spacing.header')_*_1.6)]">
         <div class="flex flex-col gap-2 sm:flex-center-between sm:flex-row px-4 py-5 sm:p-7 bg-gray-200/30 dark:bg-dark-card-shade">
             <div>
                 <h6 class="card-title">Stitching Category</h6>
             </div>
             <a href="#" class="btn b-solid btn-primary-solid" data-modal-target="editModal" @click="addModal()">Add Category</a>
         </div>
         <!-- Start All Language List Table -->
         <div class="p-3 sm:p-4">
             <div class="overflow-x-auto scrollbar-table">
                 <table class="table-auto w-full whitespace-nowrap text-left text-gray-500 dark:text-dark-text leading-none">
                     <thead class="border-b border-gray-200 dark:border-dark-border font-semibold">
                         <tr>
                             <th class="px-3.5 py-4">Parent Cat Name</th>
                             <th class="px-3.5 py-4">Category Name</th>
                             <th class="px-3.5 py-4">Amount</th>
                             <th class="px-3.5 py-4">Staus</th>
                             <th class="px-3.5 py-4">Action</th>
                         </tr>
                     </thead>
                     <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                         <tr class="hover:bg-primary-200/50 dark:hover:bg-dark-icon hover:text-gray-500 dark:hover:text-white" v-for="(item ,index)  in catList" :key="item.id" > 
                             <td class="px-3.5 py-4">{{item.parent_name}}</td>
                             <td class="px-3.5 py-4">{{item.name}}</td>
                             <td class="px-3.5 py-4">{{item.stich_amt}}</td>
                             <td class="px-3.5 py-4">{{item.status}}</td>
                             <td class="px-3.5 py-4">
                                 <div class="flex items-center gap-1">
                                     <button class="btn-icon btn-primary-icon-light size-7"  @click="editModal(item)" >
                                         <i class="ri-edit-2-line text-inherit text-[13px]"></i>
                                     </button>
                                     <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)" >
                                         <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                     </button>
                                 </div>
                             </td>
                         </tr>
                         
                     </tbody>
                 </table>
             </div>
         </div>
         <!-- End All Language List Table -->
     </div>
 </div>
 <!-- End Main Content -->

 <!-- Start Edit Modal -->
 <div id="editModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
     <div class="p-4 w-full max-w-lg max-h-full">
         <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
             <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                 <i class="ri-close-line text-inherit text-xl leading-none"></i>
             </button>
           
                  <div class=" p-4 md:p-5" >
                  
                       <form>
                  <div   v-on:keyup.enter="nextFocus">
                     <div class="mt-7">
                         <label for="tagname" class="form-label">Parent Category</label>
                         <select  v-model="cat.parentid" class="form-input">
                                <option v-for="(item, index)  in catList" :value="item.id">{{ item.name }} {{ (item.parent_name)?'('+item.parent_name+')':'' }}</option>
                         </select>

                     </div>
                     <div class="mt-7">
                         <label for="tagname" class="form-label">Category Name *</label>
                         <input type="text" v-model="cat.name" class="form-input" placeholder="Category Name" id="first_input" autocomplete="off" required >
                     </div>
                     <div class="mt-7">
                         <label for="tagname" class="form-label">Stiching Amount *</label>
                         <input type="text" v-model="cat.stich_amt" class="form-input" placeholder="Stiching Amount" id="first_input" autocomplete="off" required >
                     </div>
                     <div class="mt-7">
                         <label for="tagname" class="form-label">Category Status *</label>
                         <select  v-model="cat.status" class="form-input">
                             <option value="Active">Active</option>
                             <option value="Deactive">Deactive</option>
                         </select>

                     </div>
                     </div> 
                     
                     </form>
                     <div class="flex justify-end mt-7">
                         <button @click="save_category" id="saveBtn" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
                     </div> 
                     
                     
             </div>
         </div>
     </div>
 </div>
 <!-- End Edit Modal -->

 <!-- Start Delete Modal -->
 <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
 <!-- End Delete Modal -->
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'StichingCategory',
components: {
 
} ,
mounted(){
 this.getBasics();
},
data() {
 return {
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId: 0,
     catList:[],
     cat:{name:'',status:'Active',stich_amt:0},
     employees: {empname:'',emprole:'0',isMainAdmin:0},
 }
 }, 
methods:{
 closeModal(){
     
    $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
 },
    nextFocus(e) {
            const inputs = Array.from(e.target.form.querySelectorAll('input'));
            const index = inputs.indexOf(e.target);

            if (index < inputs.length) {
                try {
                    inputs[index + 1].focus();
                    inputs[index + 1].select();
                } catch (error) {
                    $("#saveBtn").focus();
                }
            }
        },
 addModal(){
     this.cat={name:'',status:'Active'};
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
         $("#first_input").focus();
     this.isAdd=!this.isAdd;
 },

 editModal(item){
     if(item){
         let copy = JSON.parse(JSON.stringify(item));
         this.cat=copy;
     }
     if(!this.isEdit)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },
 
 deleteModal(id){
    this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },
 async getBasics() {
       var self=this;
         axios.post('getStichingCat').then(function (response) {
                 self.catList=response.data.cats;
                 self.employees=response.data.userDetails;
                });
  },
  save_category() {
             var self = this; 
             axios.post('addStichingCat', this.cat)
                 .then(response => {
                     var msg = response.data.msg;
                     var isSuccess = response.data.status;
                     self.catList=response.data.cats;
                     self.employees=response.data.userDetails;
                     self.cat={name:'',status:'Active'};

                     //self.$swal(msg);
                     if (isSuccess == 1) {
                        self.closeModal();
                     }
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },
            delete_category() {
                var self = this; 
                axios.post('deleteStichCat', {deleteId:this.deleteId})
                    .then(response => {
                        self.catList=response.data.cats;
                        self.employees=response.data.userDetails; 
                         self.closeModal(); 
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },
}
}
</script>
